<template>
    <div class="tabs_content" id="tab-2" v-if="loadedAll">
      <section v-if="baseEntity != null && baseEntity.processed_at == null">
        <div v-translate>Marketingové oznámení ještě nebylo zpracováno.</div>
      </section>
      <section v-else>
        <div class="filter search_only">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search" />
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <modal ref="recipientsmodalref">
          <div slot="title"><translate>Seznam zařízení odběratele oznámení</translate> ({{ recipient && recipient.recipients_devices_total }})</div>
          <div slot="body">
            <RecipientDeviceList
                :id-advertising-banner="baseEntity.id"
                :idSubscriber="recipient && recipient.idSubscriber"
            />
          </div>
        </modal>
        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="advertising-banner-recipients">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.id"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <tbody>
                <RecipientsRow
                    v-for="entity in entities"
                    :entity="entity"
                    :key="entity.id"
                    :selectedEntities="selectedEntities"
                    :idAdvertisingBanner="baseEntity.id"
                    @input="select"
                    @showModal="showModal"
                ></RecipientsRow>
                <tr v-if="entities.length === 0">
                  <td colspan="8" v-translate>Nebyli nalezeni žádní příjemci.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="filteredSelectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              :disable-select-all="true"
              table-id="advertising-banner-recipients"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </section>
    </div>
  </template>

<script>
import listActions from "@/components/mixins/list-actions"
import RecipientsRow from "./RecipientsRow.vue";
import RecipientDeviceList from "./RecipientDeviceList.vue";
export default {
  name: "AdvertisingBannerRecipients",
  components: { RecipientDeviceList, RecipientsRow},
  mixins: [listActions],
  props: {
    isEditable: Boolean,
    isUpdate: Boolean,
    isProcessed: Boolean,
  },
  data(){
    return {
      baseEntity: null,
      loadedAll: false,
      entitiesKey: "recipients",
      formFields: {
        limit: 50,
        offset: 0,
        search: '',
        sort: {
          column: 'subscriberName',
          direction: 'asc'
        }
      },
      recipient: null,
    }
  },
  created(AdvertisingBannerRecipientService, AdvertisingBannerService) {
    this.entityService = AdvertisingBannerRecipientService
    this.advertisingBannerService = AdvertisingBannerService;
    this.advertisingBannerService.getEntity(this.$route.params.id, {})
        .then((data) => {
          this.baseEntity = data["advertisingBanner"];
          this.createdInit();
          this.loadedAll = true;
        });
  },
  computed: {
    sortingTableTitles() {
      return [
        {id: 1, name: this.$gettext('Odběratel'), column: 'subscriberName'},
        {id: 2, name: this.$gettext('Přečteno na zařízení/celkem'), column: 'recipients_devices_read'},
        {id: 4, name: this.$gettext('Označeno za smazané'), column: 'timestamp_deleted'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles, true)
      headers.recipients_devices_read.callback = (entity) => {return entity.recipients_devices_read +' / '+ entity.recipients_devices_read};
      headers.timestamp_deleted.callback = (entity) => {return entity.timestamp_deleted ? this.$_datetime_format(entity.timestamp_deleted) : ''};

      return headers;
    },
  },
  methods: {
    _processFormFields(formFields) {
      formFields["id"] = this.$route.params.id;
      return formFields
    },
    showModal(recipient) {
      this.recipient = recipient
      this.$refs.recipientsmodalref.showModal(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Detail/Recipients.vue